import { SECONDARY_OPTION, PRIMARY_COLOR } from "../../../foundations/constants.es.js";
function getMainColor(type) {
  return colorsBasedOnTypes[type];
}
const colorsBasedOnTypes = {
  bonusAndEconomicContributions: SECONDARY_OPTION,
  deductionsAndFiscalBonus: SECONDARY_OPTION,
  fiscalDeclarationAnd730: PRIMARY_COLOR,
  certificatesAndSupportServices: PRIMARY_COLOR,
  financialServices: PRIMARY_COLOR,
  other: PRIMARY_COLOR
};
export {
  getMainColor
};
//# sourceMappingURL=getMainColor.es.js.map
